import gql from 'graphql-tag';

const CHANGE_NEXT_BOX_DATE = gql`
  mutation changeNextBoxDate($date: String!) {
    changeNextBoxDate(date: $date)
  }
`;

export {CHANGE_NEXT_BOX_DATE};
